const defaultPageInfo =
  "Use this form to upload documents to your submitted application. Uploaded documents will be added to the case documents and directed to an analyst for review. Please check the correspondence issued for details on what is required for your case.";
const permPageInfo =
  "Use this form to upload documents to your submitted application. Uploaded documents will be added to case documents. Please check the correspondence issued for details on what is required for your case.";

const AuditResponse_uischema = (formId) => {
  const info = formId === "9089" ? permPageInfo : defaultPageInfo;
  return {
    pageTitle: {
      text: "Audit Response",
    },
    pageInfo: {
      text: info,
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "Audit Response" },
            accept_multiple: false,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "fileType",
            widget: "select",
            label: "Document Category",
            selection: [
              "Advertising Documents",
              "Applicant Resumes",
              "Employment Application/Pre-screening Tools",
              "Final Report Hiring Recommendation",
              "Hiring Official Statement",
              "Job Order",
              "Newspaper Advertisements",
              "Notice of Filing",
              "Other Supporting Documentation",
              "Qualifications and Achievements",
            ],
            validate: ["required"],
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
        ],
      },
    ],
  };
};

export default AuditResponse_uischema;
